import { Popover as PopoverPrimitive } from 'radix-ui';
import { type ComponentPropsWithoutRef, type ReactNode } from 'react';

import { CloseButton, CloseIcon, PopoverArrow, PopoverContent } from './styles';

type RadixPopoverRootProps = ComponentPropsWithoutRef<
  typeof PopoverPrimitive.Root
>;
export interface IBasePopoverProps extends RadixPopoverRootProps {
  children: ReactNode;
  dataCy?: string;
  hiddenCloseButton?: boolean;
  trigger: ReactNode;
  zIndex?: number;
  popoverMarginRight?: number;
}

export const BasePopover = ({
  children,
  dataCy = 'popover-field',
  hiddenCloseButton = false,
  trigger,
  zIndex,
  popoverMarginRight = 0,
  ...props
}: IBasePopoverProps): JSX.Element => {
  return (
    <PopoverPrimitive.Root {...props}>
      <PopoverPrimitive.Trigger asChild>{trigger}</PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverContent
          $zIndex={zIndex}
          sideOffset={5}
          data-cy={dataCy}
          $marginRight={popoverMarginRight}
        >
          {children}
          <PopoverPrimitive.Close asChild>
            {!hiddenCloseButton && (
              <CloseButton aria-label="Close" data-cy="button-closeModal">
                <CloseIcon />
              </CloseButton>
            )}
          </PopoverPrimitive.Close>
          <PopoverArrow $marginRight={popoverMarginRight} />
        </PopoverContent>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
};
